import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import RecipeCategoryModal from './Components/RecipeCategoryModal';

export default function AdminRecipeCategories()
{
    const [
        recipeCategories,
        setRecipeCategories
    ] = useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [
        selectedRecipeCategory,
        setSelectedRecipeCategory
    ] = useState<any>(null);

    const loadRecipeCategories =
        async () => {

            const response =
                await api.get(
                    '/recipe-categories'
                );

            setRecipeCategories(
                response.data
            );
        };

    useEffect(() => {

        loadRecipeCategories();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedRecipeCategory
        ) {

            await api.post(

                `/recipe-categories/${selectedRecipeCategory.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/recipe-categories',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedRecipeCategory(
            null
        );

        loadRecipeCategories();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this recipe category?'
            )
        ) {
            return;
        }

        await api.delete(
            `/recipe-categories/${id}`
        );

        loadRecipeCategories();
    };

    const moveRecipeCategoryUp =
        async (
            index: number
        ) => {

            if (
                index <= 0
            ) {
                return;
            }

            const updated =
                [...recipeCategories];

            [
                updated[index - 1],
                updated[index]
            ] = [
                updated[index],
                updated[index - 1]
            ];

            setRecipeCategories(
                updated
            );

            await api.post(
                '/recipe-categories/reorder',
                {
                    recipe_categories:
                        updated.map(
                            (
                                category,
                                position
                            ) => ({
                                id:
                                category.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            loadRecipeCategories();
        };

    const moveRecipeCategoryDown =
        async (
            index: number
        ) => {

            if (
                index >=
                recipeCategories.length - 1
            ) {
                return;
            }

            const updated =
                [...recipeCategories];

            [
                updated[index],
                updated[index + 1]
            ] = [
                updated[index + 1],
                updated[index]
            ];

            setRecipeCategories(
                updated
            );

            await api.post(
                '/recipe-categories/reorder',
                {
                    recipe_categories:
                        updated.map(
                            (
                                category,
                                position
                            ) => ({
                                id:
                                category.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            loadRecipeCategories();
        };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Recipe Categories
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedRecipeCategory(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Recipe Category
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {recipeCategories.map(
                    (
                        category,
                        index
                    ) => (

                        <tr
                            key={
                                category.id
                            }
                        >

                            <td>
                                {
                                    category.name
                                }
                            </td>

                            <td>
                                {
                                    category.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveRecipeCategoryUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveRecipeCategoryDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedRecipeCategory(
                                                category
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                category.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <RecipeCategoryModal

                    recipeCategory={
                        selectedRecipeCategory
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
